import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route  , Redirect, useLocation } from 'react-router-dom';
import GatherInfoIntro from './GatherInfoIntro';
import GatherInfoGoals from './GatherInfoGoals';
import GatherInfoContexts from './GatherInfoContexts';
import GatherInfoHistory from './GatherInfoHistory';
import GatherInfoReview from './GatherInfoReview';
import { TABS, SUBTABS } from './ConstPaths';

const propTypes = {
  firstName: PropTypes.string,
  pronouns: PropTypes.array, //[she, her, hers]
  mainGoal: PropTypes.string,
  activities: PropTypes.arrayOf(PropTypes.string),
  priority: PropTypes.string,
  platforms: PropTypes.arrayOf(PropTypes.string),
  environments: PropTypes.arrayOf(PropTypes.string),
  bodyPositions: PropTypes.arrayOf(PropTypes.string),
  indepSetup: PropTypes.string,
  indepUse: PropTypes.string,
  hasCurrentMethod: PropTypes.string,
  currentMethods: PropTypes.arrayOf(PropTypes.object),
  pastMethods: PropTypes.arrayOf(PropTypes.object),
  platformsUsed: PropTypes.arrayOf(PropTypes.string),
  updateSession: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  pronouns: ['they', 'them', 'their'],
  mainGoal: '',
  activities: [],
  priority: '',
  platforms: [],
  environments: [],
  bodyPositions: [],
  indepSetup: '',
  indepUse: '',
  hasCurrentMethod: '',
  currentMethods: [],
  pastMethods: [],
  platformsUsed: []
};

//when the url matches '/gather-info' this component renders
function GatherInfo(props) {  
  //props for goals & needs section
  const firstName = props.firstName;
  const pronouns = props.pronouns;
  const mainGoal = props.mainGoal;
  const activities = props.activities;
  const priority = props.priority;
  const platforms = props.platforms;
  //props for contexts section
  const environments = props.environments;
  const bodyPositions = props.bodyPositions;
  const indepSetup = props.indepSetup;
  const indepUse = props.indepUse;
  //props for history section
  const hasCurrentMethod = props.hasCurrentMethod;
  const currentMethods = props.currentMethods;
  const pastMethods = props.pastMethods;
  const platformsUsed = props.platformsUsed;

  const updateSession = props.updateSession;
  const {search} = useLocation();

  console.log("rendering GatherInfo, with props: " + JSON.stringify(props));

  //render a route for each sub-tab
  //include all props relevant to that sub-tab for initializing and setting
  return(
    <>
    <Switch>
      <Route path={SUBTABS.GATHER_INTRO}>
        <GatherInfoIntro firstName={firstName}/> 
      </Route>
      <Route path={[SUBTABS.GOALS + "/:step", SUBTABS.GOALS]}>
        <GatherInfoGoals 
          firstName={firstName}
          pronouns={pronouns} 
          mainGoal={mainGoal} 
          activities={activities}
          priority={priority}
          platforms={platforms}
          updateSession={updateSession}
        /> 
      </Route>
      <Route path={[SUBTABS.CONTEXTS + "/:step", SUBTABS.CONTEXTS]}>
        <GatherInfoContexts 
          firstName={firstName}
          pronouns={pronouns} 
          priority={priority}
          environments={environments}
          bodyPositions={bodyPositions}
          indepSetup={indepSetup}
          indepUse={indepUse}
          updateSession={updateSession}
        /> 
      </Route>
      <Route path={[SUBTABS.HISTORY + "/:step", SUBTABS.HISTORY]}>
        <GatherInfoHistory 
          firstName={firstName}
          pronouns={pronouns} 
          priority={priority}
          hasCurrentMethod={hasCurrentMethod}
          currentMethods={currentMethods}
          pastMethods={pastMethods}
          platformsUsed={platformsUsed}
          updateSession={updateSession}
        /> 
      </Route>
      <Route path={[SUBTABS.GATHER_REVIEW]}>
        <GatherInfoReview
          firstName={firstName}
          pronouns={pronouns} 
          mainGoal={mainGoal} 
          activities={activities}
          priority={priority}
          platforms={platforms}
          environments={environments}
          bodyPositions={bodyPositions}
          indepSetup={indepSetup}
          indepUse={indepUse}
          hasCurrentMethod={hasCurrentMethod}
          currentMethods={currentMethods}
          pastMethods={pastMethods}
          platformsUsed={platformsUsed}
        /> 
      </Route>
      {/* if path is exactly '/gather-info', go to 'gather-info/intro' */}
      <Route exact path={TABS.GATHER}>
        <Redirect to={SUBTABS.GATHER_INTRO + search} />
      </Route>
    </Switch>
    </>
  );
}

GatherInfo.propTypes = propTypes;
GatherInfo.defaultProps = defaultProps;

export default GatherInfo;
